module.exports = __webpack_public_path__ + "img/3x.b70d140.jpg";